export default "__VITE_ASSET__ZHjWsVsb__"